<div class="filter_list grid">
    <label class="inp_group">
        <div class="lbl">Логин подписки</div>
        <input [(ngModel)]="subscriptionsFilter.login" type="text" name="login" class="inp" placeholder="Логин">
    </label>
    <label class="inp_group">
        <div class="lbl">Пароль подписки</div>
        <input [(ngModel)]="subscriptionsFilter.password" type="text" name="password" class="inp" placeholder="Пароль">
    </label>
    <label class="inp_group">
        <div class="lbl">Активна ли подписка</div>
        <select [(ngModel)]="subscriptionsFilter.isActive" name="isActive" class="inp">
            <option [ngValue]="undefined">Все</option>
            <option value="true">Да</option>
            <option value="false">Нет</option>
        </select>
    </label>
    <label class="inp_group">
        <div class="lbl">ID провайдера подписки</div>
        <input [(ngModel)]="subscriptionsFilter.providerId" type="text" name="providerId" class="inp"
            placeholder="ID провайдера">
    </label>
    <label class="inp_group">
        <div class="lbl">Товары</div>
        <select class="inp" name="products" (ngModelChange)="onSelectChange($event, 'products')" [(ngModel)]="selectedProducts">
            <option [ngValue]="null">Все</option>
            <option *ngFor="let product of products" [value]="product.id">{{product.name}}</option>
        </select>
    </label>
    <label class="inp_group">
        <div class="lbl">Дата активации подписки</div>
        <input [(ngModel)]="dateRangeActivated" [locale]="dateLocaleService.locale" type="text" name="date" ngxDaterangepickerMd class="inp" placeholder="2024-12-31 - 2025-12-31"
            (change)="onDateChange($event, subscriptionsFilter, 'activatedFrom', 'activatedTo')">
    </label>
    <label class="inp_group">
        <div class="lbl">Дата истечения подписки</div>
        <input [(ngModel)]="dateRangeExpires" [locale]="dateLocaleService.locale" type="text" name="date" ngxDaterangepickerMd class="inp" placeholder="2024-12-31 - 2025-12-31"
            (change)="onDateChange($event, subscriptionsFilter, 'expiresFrom', 'expiresTo')">
    </label>
    <label class="inp_group">
        <div class="lbl">Дата последнего входа</div>
        <input [(ngModel)]="dateRangelastSeen" [locale]="dateLocaleService.locale" type="text" name="date" ngxDaterangepickerMd class="inp" placeholder="2024-12-31 - 2025-12-31"
            (change)="onDateChange($event, subscriptionsFilter, 'lastSeenFrom', 'lastSeenTo')">
    </label>
</div>